import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

const KEY = "hp_age_ok";

export const AgeGate = () => {
  const [open, setOpen] = useState(false);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(KEY) !== "yes") setOpen(true);
  }, []);

  const confirm = () => {
    localStorage.setItem(KEY, "yes");
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      data-testid="age-gate-overlay"
      className="fixed inset-0 z-[120] flex items-center justify-center bg-black/85 backdrop-blur-sm px-4"
    >
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-2xl border-t-4 border-[var(--hp-crimson)]">
        {!denied ? (
          <>
            <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-[var(--hp-crimson)] text-white font-display text-xl">
              18+
            </div>
            <h2 className="font-display text-2xl text-neutral-900">Confirm Your Age</h2>
            <p className="mt-3 text-base text-neutral-600">
              Are you 18 years old or older?
            </p>
            <div className="mt-7 flex flex-col gap-3">
              <Button
                data-testid="age-gate-yes"
                onClick={confirm}
                className="h-12 w-full bg-gradient-to-r from-red-600 to-rose-700 text-base font-bold text-white hover:from-red-700 hover:to-rose-800"
              >
                Yes, I am 18+
              </Button>
              <button
                data-testid="age-gate-no"
                onClick={() => setDenied(true)}
                className="h-12 w-full rounded-md border border-neutral-300 text-base font-semibold text-neutral-600 hover:bg-neutral-50"
              >
                No, I'm under 18
              </button>
            </div>
          </>
        ) : (
          <>
            <h2 className="font-display text-xl text-neutral-900">Come Back When You're Older</h2>
            <p className="mt-3 text-base text-neutral-600">
              Sorry, the content of this store can't be seen by a younger audience. Come back when you're older.
            </p>
            <button
              data-testid="age-gate-back"
              onClick={() => setDenied(false)}
              className="mt-6 text-sm font-semibold text-[var(--hp-crimson)] underline"
            >
              Oops, I entered incorrectly
            </button>
          </>
        )}
      </div>
    </div>
  );
};
